import React, {Component} from 'react';
import PropTypes from 'prop-types';

class MenuButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <a href="#"
         className="icon active item"
         style={{display:'flex'}}
         onClick={this.props.onMenuClick}
      >
        <h3><i className={ this.props.sideMenuVisible ? "chevron left icon" : "chevron right icon"} /></h3>
      </a>
    )
  }
}

MenuButton.PropTypes = {
    sideMenuVisible: PropTypes.bool.isRequired,
    onMenuClick: PropTypes.func.isRequired
}
export default MenuButton;




/** WEBPACK FOOTER **
 ** ./src/components/main/MenuButton.js
 **/